import { useApp } from '../context/AppContext';
import { Modal, ModalHeader, ModalBody } from '../components/Modal';

export default function SwitchUserModal() {
  const { modals, closeModal, users, roles, currentUserId, setCurrentUserId, showToast } = useApp();
  const open = modals['switch-user'];

  if (!open) return null;

  function selectUser(uid) {
    setCurrentUserId(uid);
    closeModal('switch-user');
    const u = users.find(x => x.id === uid);
    showToast(`Switched to ${u?.fname} (${u?.roleId})`);
  }

  return (
    <Modal open={!!open} size="sm" onClose={() => closeModal('switch-user')}>
      <ModalHeader
        title="Switch User / View Role"
        subtitle="Select a team member to switch perspective"
        onClose={() => closeModal('switch-user')}
      />
      <ModalBody>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {users.map(u => {
            const role = roles.find(r => r.id === u.roleId);
            const isCurrent = u.id === currentUserId;
            return (
              <div
                key={u.id}
                onClick={() => selectUser(u.id)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10,
                  padding: '10px 12px', borderRadius: 'var(--r)', cursor: 'pointer',
                  border: `1px solid ${isCurrent ? 'var(--ac-b)' : 'var(--bd)'}`,
                  background: isCurrent ? 'var(--ac-l)' : 'var(--sur)',
                  transition: 'all .12s',
                }}
              >
                <div style={{
                  width: 32, height: 32, borderRadius: '50%', background: u.color || 'var(--ac)',
                  color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 11, fontWeight: 700, flexShrink: 0,
                }}>
                  {u.initials}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, fontWeight: 500 }}>{u.fname} {u.lname}</div>
                  <div style={{ fontSize: 10, color: 'var(--tx3)' }}>{role?.name || u.roleId} · {u.status}</div>
                </div>
                {isCurrent && (
                  <span style={{ fontSize: 9, background: 'var(--ac)', color: '#fff', padding: '2px 7px', borderRadius: 10, fontWeight: 600 }}>Current</span>
                )}
              </div>
            );
          })}
        </div>
      </ModalBody>
    </Modal>
  );
}
